import axios from 'axios'
import useIPA from '@/auth/jwt/useDevice'

// initial state
const state = () => ({
  devicelist: 1,
  perPage: 10,
  pageOptions: [10, 25, 50, 100],
  totalRows: 1,
  options: [],
  sortOptions: [],
  fields: [
    { key: 'id', label: 'ID', sortable: true },
    { key: 'serial_number', label: 'Serial Number', sortable: true },
    { key: 'curr_temp', label: 'Current Temperature', sortable: true },
    { key: 'actual_date', label: 'Actual Date', sortable: true },
    { key: 'status_device', label: 'Status Device', sortable: true },
    { key: 'battery', label: 'Battery', sortable: true },
    { key: 'signal', label: 'Signal', sortable: true },
    { key: 'power', label: 'Power', sortable: true },
  ],
  items: [],
  tableItems: [],
  filteredItems: [],
  value: {
    perPage: 10,
    pageOptions: [10, 25, 50, 100],
    totalRows: 1,
    options: [],
    sortOptions: [],
    fields: [
      { key: 'id', label: 'ID', sortable: true },
      // { key: 'device_id', label: 'Device ID', sortable: true },
      { key: 'value', label: 'Current Temperature', sortable: true },
      { key: 'created_at', label: 'Actual Date', sortable: true },
      // { key: 'status_device', label: 'Status Device', sortable: true },
      // { key: 'battery', label: 'Battery', sortable: true },
      // { key: 'signal', label: 'Signal', sortable: true },
      // { key: 'power', label: 'Power', sortable: true },
    ],
    items: [],
  },
  key: {
    perPage: 10,
    pageOptions: [10, 25, 50, 100],
    totalRows: 1,
    options: [],
    sortOptions: [],
    fields: [
      { key: 'id', label: 'ID', sortable: true },
      { key: 'device_id', label: 'Device ID', sortable: true },
      { key: 'curr_temp', label: 'Current Temperature', sortable: true },
      { key: 'actual_date', label: 'Actual Date', sortable: true },
      { key: 'status_device', label: 'Status Device', sortable: true },
      { key: 'battery', label: 'Battery', sortable: true },
      { key: 'signal', label: 'Signal', sortable: true },
      { key: 'power', label: 'Power', sortable: true },
    ],
    items: [],
  },
})

// getters
const getters = {}

// actions
const actions = {
  getBySerial({ commit, state }, { serialNumber, page = 1, perPage = 20 }) {
    return new Promise((resolve, reject) => {
      const param = {
        status: `master/historical/${serialNumber}`,
        params: {
          page,
          limit: perPage,
        },
      }
      useIPA.get(param).then(response => {
        const historicalDevice = {
          rows: response.data.data,
        }
        const { pagination } = response.data
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data.data)
        }
        commit('setData', { ...historicalDevice })
        commit('setPagination', pagination)
      })
    })
  },
  getRealtime({ commit, state }, { serialNumber }) {
    return new Promise((resolve, reject) => {
      const url = `${process.env.VUE_APP_NODE_RED_API}/realtime-device/${serialNumber}`
      axios.get(url)
        .then(response => {
          const historicalDevice = {
            rows: response.data.data,
          }
          resolve(response.data)
          commit('setData', { ...historicalDevice })
        })
        .catch(error => {
          console.error('Error fetching realtime data:', error)
          reject(error)
        })
    })
  },
  getByRangeDate({ commit, state }, {
    deviceId, startDate, endDate, page = 1, limit = 20, sort = 'DESC', type, resolution
  }) {
    return new Promise((resolve, reject) => {
      const param = {
        status: `master/historical-devices`,
        params: {
          page,
          limit,
          deviceId,
          // sort,
          // resolution
        },
      }
      useIPA.get(param).then(response => {
        const historicalDevice = {
          rows: response.data.data,
        }
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data.data)
        }
        const { pagination } = response.data
        if (type === 'gauge') {
          commit('setData', { ...historicalDevice })
        } else if (type === 'table') {
          commit('setTableData', { ...historicalDevice })
          commit('setPagination', pagination)
        } else if (type === 'all') {
          commit('setData', { ...historicalDevice })
          commit('setTableData', { ...historicalDevice })
          commit('setPagination', pagination)
        }
      })
    })
  },
}

// mutations
const mutations = {
  setData(state, device) {
    let threshold = 3;
    const total = device.rows.length;
    if (total < 1000 && total > 100) {
      threshold = 5
    } else if (total > 1000) {
      threshold = 7
    }
    let showedData = Math.round(total / threshold);
    device.rows.map((element, index) => {
      if (index === 0) {
        element.showXaxis = true
      }
      else if (index === total - 1) {
        element.showXaxis = true
      }
      else if (index % showedData === 0) {
        element.showXaxis = true
      }
      else {
        element.showXaxis = false
      }
    })
    state.items = device.rows.sort((a, b) => {
        const dateA = new Date(a.actual_date);
        const dateB = new Date(b.actual_date);
        return dateA - dateB;
    });
  },
  setTableData(state, device) {
    device.rows.forEach((element, index) => {
      element.no = index + 1
    })
    state.tableItems = device.rows
    state.totalRows = device.rows.length
  },

  setFilteredData(state, device) {
    device.rows.forEach((element, index) => {
      element.no = index + 1
    })
    state.filteredItems = device.rows
  },
  setPagination(state, pagination) {
    state.perPage = pagination.limit
    state.totalRows = pagination.total_items
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
